import styled from 'styled-components';

const StyledKeylineDiv = styled.div`
  border-radius: 4px;
  border: 1px solid ${({ color, theme }) => color || theme.colors.light};
  padding: 16px;
`;

const Recommended = styled(StyledKeylineDiv)`
  border-color: ${(props) => props.theme.colors.successDark};
  border-width: 2px;
  border-radius: 0 8px 8px 8px;
`;

const Alternative = styled(StyledKeylineDiv)`
  border: none;
  background: ${(props) => props.theme.colors.pale};
  border-radius: 0 8px 8px 8px;
`;

const Inner = styled(StyledKeylineDiv)`
  border: none;
  background: ${(props) => props.theme.colors.white};
  border-radius: 0 8px 8px 8px;
`;

StyledKeylineDiv.Recommended = Recommended;
StyledKeylineDiv.Alternative = Alternative;
StyledKeylineDiv.Inner = Inner;

export default StyledKeylineDiv;
